export default __webpack_public_path__ + "static/media/316.87e36ef2.png";